
/* eslint-disable import/no-anonymous-default-export */
import {
    SET_PDT_MEMBERS,
    SET_PDT_ROLES,
    SET_PDT_PRODUCT_ROLES,
    SET_PDT_ROLES_FILTER,
    RESET_PDT_STORE,
    RESET_PDT_ROLES_FILTER,
} from '../actions/_types'

const initialState = {
    pdtMembers: [],
    pdtRoles: [],
    rolesProduct: [],
    rolesFilter: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_PDT_MEMBERS:
            return { 
                ...state, 
                pdtMembers: action.payload 
            };
        case SET_PDT_ROLES:
            return {
                ...state,
                pdtRoles: action.payload,
            };
        case SET_PDT_PRODUCT_ROLES:
            return {
                ...state,
                rolesProduct: action.payload
            }
        case SET_PDT_ROLES_FILTER:
            return {
                ...state,
                // ...state.rolesFilter,
                rolesFilter: action.payload,
            }
        case RESET_PDT_ROLES_FILTER:
            return {
                ...state,
                ...initialState.rolesFilter
            }            
        case RESET_PDT_STORE:
            return {
                ...state,
                ...initialState
            }                                                                                                                 
        default:
            return {
                ...state
            }
    }
};